<div id="pillboxContainer" class="d-flex flex-wrap">
    <rask-pillbox
        [ngClass]="{'viol3-color': arbetsorder.viol3, 'viol2-color': !arbetsorder.viol3 }"
        [text]="getViolPillboxText()">
        @if (!violVersionIsDisabled()) {
        <rask-icon icon="far fa-edit" popoverTriggers="raskDefault">
            <rask-radiobutton-group label="Violversion" [buttons]="activetypes" [(ngModel)]="violVersion" [disabled]="violVersionIsDisabled()" (change)="changeViolversion()"></rask-radiobutton-group>
        </rask-icon>
        }
    </rask-pillbox>
</div>
